"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DropdownOption = exports.DropdownContent = exports.DropdownTrigger = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var className = function className(props, state) {
  return (0, _classnames.default)('Dropdown', {
    'Dropdown--grey': props.grey,
    'Dropdown--is-open': state.isOpen
  });
};

var itemClassName = function itemClassName(props) {
  return (0, _classnames.default)('Dropdown__contentItem', {
    'Dropdown__contentItem--disabled': props.disabled
  });
};

var contentClassName = function contentClassName(props) {
  return (0, _classnames.default)('Dropdown__content', {
    'Dropdown__content--left-align': props.align === 'left'
  });
};

var DropdownTrigger = function DropdownTrigger(_ref) {
  var isOpen = _ref.isOpen,
      children = _ref.children,
      onClick = _ref.onClick;
  return _react.default.createElement("div", {
    className: "Dropdown__trigger",
    onClick: onClick
  }, children, _react.default.createElement("i", {
    className: "dbi dbi-arrow-".concat(isOpen ? 'up' : 'down')
  }));
};

exports.DropdownTrigger = DropdownTrigger;

var DropdownContent = function DropdownContent(props) {
  var children = props.children;
  return _react.default.createElement("div", {
    className: contentClassName(props)
  }, children);
};

exports.DropdownContent = DropdownContent;

var DropdownOption = function DropdownOption(props) {
  var children = props.children,
      onClick = props.onClick;
  return _react.default.createElement("div", {
    className: itemClassName(props),
    onClick: onClick
  }, children);
};

exports.DropdownOption = DropdownOption;

var Dropdown =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Dropdown, _React$Component);

  function Dropdown(props) {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dropdown).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      isOpen: false
    });

    _this._toggleDropdown = _this._toggleDropdown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._handleOnClickWindow = _this._handleOnClickWindow.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('click', this._handleOnClickWindow);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('click', this._handleOnClickWindow);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          exitOnClick = _this$props.exitOnClick;
      var isOpen = this.state.isOpen;
      return _react.default.createElement("div", {
        className: className(this.props, this.state),
        ref: function ref(_ref2) {
          return _this2.dropdown = _ref2;
        },
        onClick: exitOnClick ? this._toggleDropdown : null
      }, children.map(function (c, i) {
        return c.type.name !== DropdownTrigger.name ? c : _react.default.cloneElement(c, {
          isOpen: isOpen,
          onClick: _this2._toggleDropdown,
          key: i
        });
      }));
    }
  }, {
    key: "_toggleDropdown",
    value: function _toggleDropdown() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: "_handleOnClickWindow",
    value: function _handleOnClickWindow(e) {
      var isOpen = this.state.isOpen;

      if (isOpen && e.target !== this.dropdown && !this.dropdown.contains(e.target)) {
        this._toggleDropdown();
      }
    }
  }]);

  return Dropdown;
}(_react.default.Component);

var _default = Dropdown;
exports.default = _default;